export const AI_OPTIMIZATION_KPI_STATUS = Object.freeze({
  LOADING: "LOADING",
  READY: "READY",
  STALE: "STALE",
  ERROR_WITH_SAVED: "ERROR_WITH_SAVED",
  ERROR_EMPTY: "ERROR_EMPTY",
});

export const AI_OPTIMIZATION_KPI_STATUS_MESSAGES = Object.freeze({
  [AI_OPTIMIZATION_KPI_STATUS.LOADING]: "Current KPI stats are refreshing.",
  [AI_OPTIMIZATION_KPI_STATUS.READY]:
    "Current KPI stats are loaded and campaign intelligence is fresh.",
  [AI_OPTIMIZATION_KPI_STATUS.STALE]:
    "KPIs are current. Run Generate AI Update to refresh the saved campaign intelligence.",
  [AI_OPTIMIZATION_KPI_STATUS.ERROR_WITH_SAVED]:
    "Current KPI stats could not be refreshed. Published campaign intelligence is shown, but freshness could not be verified.",
  [AI_OPTIMIZATION_KPI_STATUS.ERROR_EMPTY]:
    "Current KPI stats could not be refreshed. KPI cards remain unavailable until canonical metrics load.",
});

const STATUS_TYPES = Object.freeze({
  [AI_OPTIMIZATION_KPI_STATUS.LOADING]: "info",
  [AI_OPTIMIZATION_KPI_STATUS.READY]: "success",
  [AI_OPTIMIZATION_KPI_STATUS.STALE]: "muted",
  [AI_OPTIMIZATION_KPI_STATUS.ERROR_WITH_SAVED]: "info",
  [AI_OPTIMIZATION_KPI_STATUS.ERROR_EMPTY]: "error",
});

export function resolveAiOptimizationKpiStatus({
  isLoading = false,
  hasCurrentKpis = false,
  hasSavedIntelligence = false,
  savedIntelligenceFresh = true,
  currentKpiError = "",
} = {}) {
  let state = AI_OPTIMIZATION_KPI_STATUS.READY;

  if (isLoading) {
    state = AI_OPTIMIZATION_KPI_STATUS.LOADING;
  } else if (currentKpiError) {
    state = hasSavedIntelligence
      ? AI_OPTIMIZATION_KPI_STATUS.ERROR_WITH_SAVED
      : AI_OPTIMIZATION_KPI_STATUS.ERROR_EMPTY;
  } else if (!hasCurrentKpis) {
    state = hasSavedIntelligence
      ? AI_OPTIMIZATION_KPI_STATUS.ERROR_WITH_SAVED
      : AI_OPTIMIZATION_KPI_STATUS.ERROR_EMPTY;
  } else if (hasSavedIntelligence && savedIntelligenceFresh === false) {
    state = AI_OPTIMIZATION_KPI_STATUS.STALE;
  }

  return {
    state,
    message: AI_OPTIMIZATION_KPI_STATUS_MESSAGES[state],
    type: STATUS_TYPES[state],
  };
}
